import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getModerationSettingsKey } from '../../utils/keys';
export const useModerationSettings = (options) => {
    const { useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const moderationSettingsKey = getModerationSettingsKey();
    return useQuery(moderationSettingsKey, () => client.moderation.settings(), useQueryOptions);
};
//# sourceMappingURL=useModerationSettings.js.map